export class DomUtils {
  public static isInViewport(element: Element,
                             direction?: 'v' | 'h'): boolean {
    const bounding = element.getBoundingClientRect();

    let isInViewportHorizontal = true;
    let isInViewportVertical = true;

    if (direction !== 'v') {
      isInViewportHorizontal = bounding.right <= (window.innerWidth || window.document.documentElement.clientWidth) && bounding.left >= 0;
    }

    if (direction !== 'h') {
      isInViewportVertical = bounding.bottom <= (window.innerHeight || window.document.documentElement.clientHeight) && bounding.top >= 0;
    }

    return isInViewportHorizontal && isInViewportVertical;
  }

  public static toggleOverlayClass(remove?: boolean): void {

    const root = document.getElementsByTagName('html')[0];
    if (remove) {
      root.classList.remove('overlay-opened');
    } else {
      root.classList.add('overlay-opened');
    }

  }
}
